module.exports = __webpack_public_path__ + "img/review.f98d098.webp";